import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export const isYearRule = (v: Nullable<number>): boolean | string => {
  if (!isValuePresent(v)) {
    return true; // Allow empty values
  }

  const yearPattern = /^\d{4}$/;
  return yearPattern.test(String(v)) || 'Year must be a 4-digit number';
};
